import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Autocomplete from '@mui/material/Autocomplete';
import { MultipleSelectChip } from './MultiSelectChip.tsx';
import * as columns from '../misc/Columns.ts';
import * as lov_info_dict from '../misc/LovInfoDictionary.ts';
import * as lov_infos from '../misc/LovInfo.ts';
import { SearchDropDown } from './SearchDropDown.tsx';
import { useSnackbarMessage } from './SnackMessge.tsx';
import { Typography } from '@mui/material';

const widthStyleDataEntry = { "width": "500px" }

export function getEnabledDisabledBorder() {
    return {
        "& .MuiInputBase-colorPrimary": {
            "& > fieldset": {
                borderColor: "#000000"
            }
        },
        "& .MuiInputBase-root.MuiInputBase-colorPrimary": {
            "& > fieldset": {
                borderColor: "#000000"
            }
        },
        "& .MuiInputBase-root.Mui-disabled": {
            "& > fieldset": {
                borderColor: "#cccccc"
            }
        },
        '.MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 1)',
        },
    }
}

export function NewOrEdit({ rowData, columns, changedData, lovs }: {
    rowData: any, columns:
    columns.ColumnInfo[],
    changedData: (data: any) => void,
    lovs: lov_info_dict.LovInfoDictionary | {}
}): JSX.Element {

    const { showMessage } = useSnackbarMessage();

    const getValue = (name) => {
        var column = columns.find(column => column.id === name)
        if (column !== undefined) {
            if (column.type === 'date') {
                return rowData[name].split('T')[0]
            }
        }

        return rowData[name]
    }

    const handleChangeOption = (name, label, value) => {
        var newFormData = { ...rowData };
        newFormData[name] = value;
        changedData(newFormData);
    }

    const handleTextChange = (event) => {
        var newFormData = { ...rowData }
        newFormData[event.target.name] = event.target.value
        changedData(newFormData)
    }

    const handleBoolChange = (name, value) => {
        var newFormData = { ...rowData };
        newFormData[name] = value === 'true';
        changedData(newFormData)
    }

    const handleChangeMultiSelect = (name, value) => {
        var newFormData = { ...rowData };
        newFormData[name] = value;
        changedData(newFormData);
    }

    const filterAuto = (x, state) => {
        if (state.inputValue == null || state.inputValue === '')
            return [];

        const contains = ["a", "b", "c"].filter(y => y.includes(String(state.inputValue)));
        console.log("contains", contains)
        console.log("x:", x)
        console.log("state:", state)
        return contains;
    }

    const formContents = () => {

        console.log("columns", columns)

        return <span style={{ "margin": "40px" }}>

            <Grid container spacing={{ xs: 1, md: 1 }} columns={{ xs: 4, sm: 8 }} >

                {
                    rowData &&

                    columns
                        .filter(column => column.id in rowData)
                        .filter(column => column.hidden !== true)
                        .map((column: columns.ColumnInfo) => (
                            !column.hidden && (
                                <>

                                    <Grid item xs={2} sm={4} md={4} key={column.id + 'name'}>

                                        {column.disp_name}

                                    </Grid>

                                    <Grid item xs={2} sm={4} md={4} key={column.id + 'value'}>

                                        {(column.type === 'str' || column.type == 'url') && (
                                            <TextField
                                                id={column.id}
                                                key={column.id}
                                                rows={column.rows}
                                                multiline={column.rows > 1}
                                                disabled={!column.editable}
                                                name={column.id}
                                                value={getValue(column.id)}
                                                style={widthStyleDataEntry}
                                                onChange={handleTextChange} />
                                        )}


                                        {column.type === 'lov' && column.lov && !column.multi && (
                                            <>
                                                <Autocomplete
                                                    id={column.id}
                                                    key={column.id}
                                                    disablePortal
                                                    disableClearable={true}
                                                    style={widthStyleDataEntry}
                                                    options={lovs[column.lov].map((option) => option.label)}
                                                    value={getValue(column.id)}
                                                    onChange={(event, newInputValue) => {
                                                        handleChangeOption(column.id, newInputValue, newInputValue);
                                                    }}

                                                    renderInput={(params) => <TextField {...params} />}
                                                />


                                            </>

                                        )}

                                        {column.type === 'dynamic_lov' && column.lov !== undefined && !column.multi && (
                                            <>
                                                <SearchDropDown
                                                    col_id={column.id}
                                                    searchFunction={async (col_id, value) => {
                                                        try {
                                                            const values: lov_infos.LovInfo[] = await lovs[column.lov ?? ''](value); //TODO: fix
                                                            return values;

                                                        } catch (error) {
                                                            showMessage("Error fetching data. Please try again.");
                                                            return [];

                                                        }
                                                    }}
                                                    value={getValue(column.id)}
                                                    onHandleChangeOption={(id, label, value) => handleChangeOption(id, label, value)}
                                                />
                                                <Typography variant="caption">
                                                    Note: Start typing to filter '{column.disp_name}'.
                                                </Typography>
                                            </>

                                        )}

                                        {column.type === 'lov' && column.lov && column.multi && (
                                            <MultipleSelectChip
                                                id={column.id}
                                                style={widthStyleDataEntry}
                                                sx={getEnabledDisabledBorder()}

                                                selected={getValue(column.id)}
                                                setSelected={(value) => handleChangeMultiSelect(column.id, value)}

                                                names={lovs[column.lov].map(option => option.value)}
                                            />

                                        )}

                                        {column.type === 'boolean' && (

                                            <Select
                                                id={column.id}
                                                value={getValue(column.id)}
                                                style={widthStyleDataEntry}

                                                onChange={(event) => handleBoolChange(column.id, event.target.value)}
                                            >
                                                <MenuItem value={'true'}>True</MenuItem>
                                                <MenuItem value={'false'}>False</MenuItem>
                                            </Select>

                                        )}

                                        {column.type === 'date' && (
                                            <TextField
                                                key={column.id}
                                                id="date"
                                                value={getValue(column.id)}
                                                label={column.disp_name}
                                                type="date"
                                                name={column.id}
                                                style={widthStyleDataEntry}
                                                disabled={!column.editable}
                                                onChange={handleTextChange}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        )}

                                    </Grid>
                                </>
                            )
                        ))
                }
            </Grid>
        </span>
    }


    return (

        <>
            {formContents()}
        </>


    );
}

